import { Modal, Button, Typography, CircularProgress } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface ConfirmDialogProps {
  open: boolean;
  isLoading: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
  dialogTitle: string;
  dialogContent: string;
  proceedButtonContent: string;
}

const ConfirmDialog = ({
  open,
  isLoading,
  handleCancel,
  handleConfirm,
  dialogContent,
  dialogTitle,
  proceedButtonContent,
}: ConfirmDialogProps) => {
  return (
    <Modal
      open={open}
      onClose={handleCancel}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <div
        style={{
          width: '604px',
          height: '211px',
          position: 'absolute',
          top: '20%',
          left: '50%',
          transform: 'translate(-50%, -40%)',
          borderRadius: 6,
          background: '#FFF',
          boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.28)',
          display: 'inline-flex',
          padding: 24,
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 16,
        }}
      >
        <Typography
          variant='h6'
          color='textPrimary'
          style={{
            fontFamily: 'Schibsted Grotesk',
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '125%',
            color: 'var(--Black, #181818)',
          }}
        >
          {/* DIALOG TITLE */}
          {dialogTitle}
        </Typography>
        <Typography
          variant='body1'
          color='var(--neutral-white-bg-700, #4F4F4F)'
          style={{
            fontFamily: 'Schibsted Grotesk',
            fontSize: 16,
            fontWeight: 400,
            lineHeight: '150%',
          }}
        >
          {/* DIALOG CONTENT */}
          {dialogContent}
        </Typography>
        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            width: '100%',
            gap: 16,
          }}
        >
          <Button
            disableElevation
            onClick={handleCancel}
            style={{
              display: 'flex',
              padding: '12px 16px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
              borderRadius: 6,
              border: '1px solid var(--neutral-white-bg-200, #D1D1D1)',
              textTransform: 'none',
            }}
          >
            <Typography
              variant='body2'
              color='var(--Black, #181818)'
              style={{
                fontFamily: 'Schibsted Grotesk',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '125%',
              }}
            >
              <FormattedMessage defaultMessage='Cancel' />
            </Typography>
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={handleConfirm}
            disableElevation
            style={{
              minWidth: '140px',
              display: 'flex',
              padding: '12px 16px',
              justifyContent: 'center',
              alignItems: 'center',
              textTransform: 'none',
              gap: 10,
              borderRadius: 6,
              background: 'var(--secondary-blue-600-secondary-brand, #2449FC)',
            }}
          >
            {isLoading ? (
              <CircularProgress
                size={20}
                style={{ color: 'var(--White, #FFF)' }}
              />
            ) : (
              <Typography
                variant='body2'
                color='var(--White, #FFF)'
                style={{
                  fontFamily: 'Schibsted Grotesk',
                  fontSize: 14,
                  fontWeight: 600,
                  lineHeight: '125%',
                }}
              >
                {/* PROCEED BUTTON CONTENT */}
                {proceedButtonContent}
              </Typography>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
